<div class="loading-screen-wrapper" *ngIf="this.loadingMin==true && session==1">
    <img class="loadingNewImg" src="../../../assets/images/loading2.gif">
</div>
<div class="loading-screen-wrapper" *ngIf="this.loadingMin2==true && session==2" [ngStyle]="{'width': this.width,'heigth': this.heigth}">
    <img class="loadingNewImg" src="../../../assets/images/loading2.gif">
</div>